import { FC } from 'react';
import clsx from 'clsx';
import { Icon } from '@kontentino/ui';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { useModalHistory } from 'context/ModalRouter';
import { modalRoutes } from 'constants/routes';
import {
  PublicCommentBubble,
  PUBLIC_COMMENT_BUBBLE_CLASS,
} from './PublicCommentBubble';
import { usePublicCommentsQuery } from './hooks/usePublicCommentsQuery';

interface CommentSectionProps {
  token: string;
  postId: number;
}

const PLACEHOLDER_COMMENT =
  'Hi there 👋🏼 I just sent you this post for approval ✅. Let me know what you think!';

export const CommentSection: FC<CommentSectionProps> = ({ token, postId }) => {
  const modalHistory = useModalHistory();
  const { data, hasNextPage, ref, rootRef } = usePublicCommentsQuery({
    postId,
    token,
  });

  const openInviteModal = () =>
    modalHistory.push({
      hash: modalRoutes.PUBLIC_INVITE_USER,
      state: { actionType: 'comment' },
    });

  const hasComments = data.length > 0;

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-items-center tw-gap-2 tw-font-tobias tw-text-xl tw-font-semibold tw-text-[#f68eef]">
        <Icon icon={faComment} />
        <span>Comments</span>
      </div>

      <div
        ref={rootRef}
        className="tw-flex tw-max-h-[420px] tw-flex-col tw-gap-3 tw-overflow-y-auto"
      >
        {hasComments ? (
          data.map((comment) => (
            <PublicCommentBubble key={comment.id} comment={comment} />
          ))
        ) : (
          <div
            className={clsx(PUBLIC_COMMENT_BUBBLE_CLASS, 'tw-bg-accent-100')}
          >
            {PLACEHOLDER_COMMENT}
          </div>
        )}
        {hasNextPage && <div ref={ref} className="tw-h-1" />}
      </div>

      <button
        type="button"
        className="tw-shadow tw-flex tw-w-full tw-cursor-text tw-items-center tw-gap-3 tw-rounded-full tw-bg-white tw-py-2 tw-pl-2 tw-pr-2 tw-text-left tw-text-sm tw-text-grayscale-100 tw-shadow-black"
        onClick={openInviteModal}
        data-cy="public-post-preview_comment-input"
      >
        <img
          src="https://api.dicebear.com/9.x/thumbs/svg?seed=Felix"
          alt=""
          className="tw-h-9 tw-w-9 tw-shrink-0 tw-rounded-full tw-bg-white tw-shadow-md"
        />
        <span className="tw-flex-1">Write a comment...</span>
        <span className="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-100 tw-text-white">
          <Icon icon={faArrowUp} />
        </span>
      </button>
    </div>
  );
};
